var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParkBurning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 58.000000 56.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,56.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M67 522 c-15 -16 -17 -48 -17 -234 0 -195 2 -216 18 -231 16 -15 48 -17 234 -17 195 0 216 2 231 18 15 16 17 48 17 234 0 195 -2 216 -18 231 -16 15 -48 17 -234 17 -195 0 -216 -2 -231 -18z m158 -93 c9 -17 11 -29 5 -29 -6 0 -8 -15 -4 -39 4 -27 1 -50 -11 -75 -12 -25 -16 -50 -12 -77 4 -33 2 -40 -11 -37 -28 5 -33 55 -11 111 23 57 18 104 -12 115 -17 7 -17 8 2 40 23 36 32 34 54 -9z m104 6 c15 -27 17 -35 6 -35 -11 0 -11 -7 -4 -35 8 -28 6 -44 -12 -84 -17 -41 -19 -56 -11 -81 10 -27 9 -30 -8 -30 -28 0 -37 59 -16 101 26 52 20 120 -11 130 -9 3 -7 13 7 37 11 17 22 32 24 32 2 0 13 -16 25 -35z m106 3 c11 -19 14 -33 8 -35 -6 -2 -8 -22 -6 -47 4 -29 0 -55 -12 -80 -12 -24 -15 -47 -11 -71 5 -27 4 -35 -7 -35 -29 0 -36 68 -12 110 25 44 17 120 -12 120 -8 0 -13 3 -11 8 23 46 32 62 37 62 4 0 15 -14 26 -32z m13 -320 c-4 -10 -43 -13 -153 -13 -110 0 -149 3 -152 13 -4 9 31 12 152 12 121 0 156 -3 153 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkBurning);
export default __webpack_public_path__ + "static/media/ParkBurning.4b5ecbaa5d0cfe5d59ef39c95c36c444.svg";
export { ForwardRef as ReactComponent };